<template>
  <section class="author">微信授权登录中</section>
</template>

<script>
import{encrypt,setCookie,getCookie} from "@/utils"

export default {
  data() {
    return {
      code: ""
    };
  },
  created() {
    if (this.$route.query.code) {
      this.code = this.$route.query.code;
      this.fetchWechatOpenid(this.$route.query.code);
    } else {
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3ecf2c6f024ac482&redirect_uri=https://hx.suhuishou.com/mobile/wechat/author&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
    }
    //
  },
  methods: {
    fetchWechatOpenid(code) {
      let params = {
        code:code
      };
      this.$store.dispatch("wechat/fetchWechatOpenid", { params }).then(() => {
        let data = this.$store.state.wechat.wechatauthor;
        if(data.openid){
          let wechatauthor = JSON.stringify(data);
          setCookie("wechatauthor", encrypt(wechatauthor), true);
        }
        if(getCookie("topath")){
          this.$router.push({ path: getCookie("topath") })
        }else{
          this.$router.push({ path: "/mobile" })
        }
      });
    }
  }
};
</script>

<style scoped>
.author{
  padding:0.4rem;
}
</style>
